<div class="mt-5">
  <div class="row">
    <div class="col-md-3">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">Search</h5>
          <!-- Material inline form -->
          <form >
            <div class="md-form" style="min-height: 3em;">
              <input #confirmationNumber mdbInput type="text" id="form2" class="form-control">
              <label for="form2">Confirmation</label>
            </div>

            <button mdbBtn type="submit" size="sm" 
              [disabled]="confirmationNumber.value === ''"
              class="btn btn-primary mb-0 float-right"
              (click)="search(confirmationNumber.value)">Search</button>
          </form>
          <!-- Material inline form -->
        </div>
      </div>



    </div>

    <div class="col-md-3">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">Default Zones</h5>

          <form>
            <div class="md-form" style="min-height: 3em;">
              <p class="card-text" *ngIf='(viewState$ | async) as v'>
                <span *ngIf="v.isLoading">Loading...</span>
                <span>{{(viewState$ | async).data.length}}</span>
              </p>
            </div>

            <button mdbBtn type="submit" size="sm" class="btn btn-primary mb-0 float-right" (click)="viewDefaultPricingZones()">View</button>
          </form>



        </div>
      </div>

    </div>
  </div>


</div>